import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { ConversationChannel, Participant } from '@vendasta/conversation';
import { BehaviorSubject } from 'rxjs';
import { InboxNavigationService } from '../../../core/src/lib/inbox-navigation.service';
import { SubjectParticipant } from '../../../core/src/lib/interface/conversation.interface';

interface SendMessageButtonConfig {
  currentParticipant?: Participant;
  subjectParticipants: SubjectParticipant[];
  channel: ConversationChannel;
  prefilledMessage?: string;
}
@Component({
  selector: 'inbox-button-send-message',
  templateUrl: './button-send-message.component.html',
  styleUrls: ['./button-send-message.component.scss'],
  standalone: false,
})
export class ButtonSendMessageComponent {
  private readonly inboxNav = inject(InboxNavigationService);

  @Input() config: SendMessageButtonConfig;
  @Input() type: 'primary' | 'secondary' | 'alternative' | 'link' | 'icon' | 'menu' | 'text' = 'primary';
  @Input() primaryIcon?: boolean;
  @Output() closeModal = new EventEmitter();
  @ViewChild('content', { read: ElementRef, static: false }) content: ElementRef;

  private creatingConversation$$ = new BehaviorSubject<boolean>(false);
  creatingConversation$ = this.creatingConversation$$.asObservable();

  sendMessage(): void {
    this.inboxNav.gotoConversation(
      this.config?.subjectParticipants,
      this.config?.currentParticipant,
      this.config?.channel,
      this.config?.prefilledMessage,
    );
    this.closeModal.emit();
  }
}
